export default __webpack_public_path__ + "static/media/add-note.8e49302e.svg";